"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExceptionHandler_1 = require("../../models/common/base/ExceptionHandler");
var AppSettings = /** @class */ (function () {
    function AppSettings() {
    }
    AppSettings.prototype.init = function (dataProviderUrl, productVariantName, skipAuthentication, authScheme) {
        this.dataProviderUrl = dataProviderUrl;
        this.productVariantName = productVariantName;
        this.skipAuthentication = skipAuthentication;
        this.authScheme = authScheme;
    };
    AppSettings.prototype.isInitialised = function () {
        if ((!this.dataProviderUrl) || (!this.productVariantName) || (this.skipAuthentication === undefined) || (!this.authScheme)) {
            return false;
        }
        return true;
    };
    AppSettings.prototype.verifyUrlInitializationState = function () {
        if (!this.isInitialised()) {
            var exceptionHandler = new ExceptionHandler_1.ExceptionHandler();
            throw new Error(exceptionHandler.buildExceptionFromErrorMessage('Bad request', 400, 'Data uninitialized', "Data is not initialized. Please call sce.init() to initialize"));
        }
    };
    AppSettings.prototype.reset = function () {
        this.dataProviderUrl = undefined;
        this.productVariantName = undefined;
        this.skipAuthentication = undefined;
        this.authScheme = undefined;
    };
    return AppSettings;
}());
var appSettings = new AppSettings();
exports.default = appSettings;
//# sourceMappingURL=AppSettings.js.map